import React, { useState, useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ManagementUserPage from './dashboard/management/managementUser';
import AddUserPage from './dashboard/management/addUser';

import ManagementKelasPage from './dashboard/management/managementKelas';
import AddKelas from './dashboard/management/addKelas';
import UpdateKelas from './dashboard/management/updateKelas';
import ManagementBookingPage from './dashboard/management/managementBooking';
import DetailKelasPage from './dashboard/management/detailKelas';

import ManagementTrainerPage from './dashboard/management/managementTrainer';

import ManagementDietPage from './dashboard/management/managementDiet';
import AddDiet from './dashboard/management/addDiet';
import UpdateDiet from './dashboard/management/updateDiet';

import ManagementFeedbackPage from './dashboard/management/managementFeedback';
import DetailFeedbackPage from './dashboard/management/detailFeedback';

import Login from './login/login';
import Protected from './components/Protected';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route index element={<Login />} />
        <Route path="/dashboard/management/user" element={
          <Protected allowedRoles={[5]}>
            <ManagementUserPage />
          </Protected>
        } />
        <Route path="/dashboard/management/kelas" element={
          <Protected allowedRoles={[5]}>
            <ManagementKelasPage />
          </Protected>
        } />
        <Route path="/dashboard/management/kelas/add" element={
          <Protected allowedRoles={[5]}>
            <AddKelas />
          </Protected>
        } />
        <Route path="/dashboard/management/kelas/update/:id" element={
          <Protected allowedRoles={[5]}>
            <UpdateKelas />
          </Protected>
        } />
        <Route path="/dashboard/management/user" element={
          <Protected allowedRoles={[5]}>
            <ManagementUserPage />
          </Protected>
        } />
        <Route path="/dashboard/management/user/add" element={
          <Protected allowedRoles={[5]}>
            <AddUserPage />
          </Protected>
        } />
        <Route path="/dashboard/management/booking" element={
          <Protected allowedRoles={[5]}>
            <ManagementBookingPage />
          </Protected>
        } />
        <Route path="/dashboard/management/trainer" element={
          <Protected allowedRoles={[5]}>
            <ManagementTrainerPage />
          </Protected>
        } />
        <Route path="/dashboard/management/diet" element={
          <Protected allowedRoles={[5]}>
            <ManagementDietPage />
          </Protected>
        } />
        <Route path="/dashboard/management/diet/add" element={
          <Protected allowedRoles={[5]}>
            <AddDiet/>
          </Protected>
        } />
        <Route path="/dashboard/management/diet/update/:id" element={
          <Protected allowedRoles={[5]}>
            <UpdateDiet />
          </Protected>
        } />
        <Route path="/dashboard/management/feedback" element={
          <Protected allowedRoles={[2]}>
            <ManagementFeedbackPage />
          </Protected>
        } />
        <Route path="/dashboard/management/feedback/detail/:id" element={
          <Protected allowedRoles={[2]}>
            <DetailFeedbackPage/>
          </Protected>
        }/>

      </Routes>
    </BrowserRouter>
  );
}

export default App;